import { Badge, Box, Group, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const CarrierCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Group gap={4}>
            <Text>{rowData.carrier || 'USCellular'}</Text>
            {rowData.upstreamCarrier !== rowData.carrier ? (
                <Badge
                    ms={'xs'}
                    size={'sm'}>
                    {rowData.upstreamCarrier}
                </Badge>
            ) : (
                <Badge
                    ms={'xs'}
                    size={'sm'}
                    color={'gray'}>
                    Non-MVNO
                </Badge>
            )}
        </Group>
    );
};

const CarrierColumn = () => ({
    accessorKey: 'carrier',
    header: 'Carrier',
    size: 1,
    Cell: ({ cell }) => <CarrierCell cell={cell} />,
});
export default CarrierColumn;
